import { FC, useState } from 'react';
import { Accept, useDropzone } from 'react-dropzone';
import { InputProps, withField } from '../withField';
import { FileInputContainer } from './shared';

interface FileInputProps extends InputProps<File[]> {
  placeholder?: string;
  accept?: Accept;
  onChange: (files: File[]) => void | Promise<void>;
}
export const FileInput: FC<FileInputProps> = ({ onChange, value, accept, placeholder }) => {
  const [loading, setIsLoading] = useState(false);

  const onDrop = async (files: File[]) => {
    setIsLoading(true);
    await onChange(files);
    setIsLoading(false);
  };
  const state = useDropzone({
    onDrop: onDrop,
    accept,
    maxFiles: 1
  });

  return (
    <FileInputContainer state={state} loading={loading} placeholder={placeholder}>
      {value?.length}
    </FileInputContainer>
  );
};

export const FileField = withField<File[], FileInputProps>(FileInput);
